// extracted by mini-css-extract-plugin
module.exports = {"entered":"transition-transition-module--entered--1y_2e","exiting":"transition-transition-module--exiting--3-YAw"};